import React, { PureComponent } from 'react';
import _ from 'lodash';
import TextField from 'material-ui/TextField';
import { getImage } from 'MyAccount/ViewDesigns/helpers/uploadHelper';
import ImageProperties from './ImageProperties';

const WEB_ADDRESS_LOADER_INITIAL_STATE = { errorMessage: null, img: null };

export default class WebAddressLoader extends PureComponent {
  constructor(props) {
    super();
    WEB_ADDRESS_LOADER_INITIAL_STATE.initialImageProperties = props.initialImageProperties;
    this.state = WEB_ADDRESS_LOADER_INITIAL_STATE;
  }

  componentDidMount() {
    const {initialImageProperties} = this.props;
    if (initialImageProperties && !_.isEmpty(initialImageProperties.src)) {
      this.onUrlChange();
    }
  }

  onUrlChange = _.debounce(() => {
    const src = this.refs.url.getValue();
    const initialImageProperties = this.state;
    const {onChange} = this.props;
    if (_.isEmpty(src)) {
      this.setState(WEB_ADDRESS_LOADER_INITIAL_STATE);
    } else {
      getImage(src, (img) => {
        if (img !== null) {
          this.setState({...WEB_ADDRESS_LOADER_INITIAL_STATE, img, initialImageProperties: _.merge({}, {height: img.height, width: img.width, aspectRatio: img.width / img.height}, initialImageProperties)});
        } else {
          this.setState({
            ...WEB_ADDRESS_LOADER_INITIAL_STATE,
            errorMessage: 'Oops!, We can\'t find an image at that URL, A typo maybe?'
          });
        }
        if (onChange && img !== this._lastImg) {
          onChange(img);
          this._lastImg = img;
        }
      });
    }
  }, 1000, {leading: true, trailing: true});

  getImagePropertiesRef() {
    return this.refs.addressLoaderImageProperties;
  }


  getImage() {
    return this.state.img;
  }

  _lastImg = null;

  render() {
    const {img, errorMessage, initialImageProperties} = this.state;
    let initialUrl;
    if (initialImageProperties) {
      initialUrl = initialImageProperties.src;
    }
    return (
      <div>
        <TextField
          style={{width: '100%'}}
          floatingLabelText="Image URL"
          hintText="Paste an image URL here"
          onChange={this.onUrlChange}
          ref="url"
          errorStyle={{float: 'left'}}
          errorText={errorMessage}
          defaultValue={initialUrl}
        />
        <ImageProperties img={img} initialImageProperties={initialImageProperties} ref="addressLoaderImageProperties"/>
      </div>
    );
  }
}
